export async function getUser(userRepository, nick) {
    return await userRepository.getUser(nick)
}